module.exports = __webpack_public_path__ + "static/media/menu-background.d84211c3.png";